import React, { useEffect, useState, useRef } from "react";
import {
    createDayModel,
    updateDayModel,
    getDayModel,
    destroyDayModel,
} from "../../../../../_api/DayModel";
import { useNavigate, useParams } from "react-router-dom";
import { InputForm } from "../../../../../_helpers/components/Forms/InputLabel";
import { Button } from "../../../../../_helpers/components/Button";
import toast from "react-hot-toast";
import { Loader } from "../../../../../_helpers/components/Forms/Loader";
import { HourSlice } from "../../../../../_helpers/components/Forms/HourSlice";
import { getHourTypes } from "../../../../../_api/HourType";
import { BackButton } from "../../../../../_helpers/components/BackButton";

const AddDayModel = () => {
    const navigate = useNavigate();
    const { dm_id } = useParams();
    const [name, setName] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [hourSlices, setHourSlices] = useState([]);
    const [hoursType, setHoursType] = useState([]);
    const defaultHourTypeId = useRef(-1);

    const loadHoursTypes = async () => {
        await getHourTypes().then((resp) => {
            const res = resp.data.map((res) => {
                if (defaultHourTypeId.current === -1 || (res.is_work === true && res.is_absence !== true && res.is_on_site === true)) {
                    defaultHourTypeId.current = res.id;
                }
                return {
                    id: res.id,
                    name: res.name,
                    abbreviation: res.abbreviation,
                    created_at: new Date(res.created_at).toLocaleDateString(),
                    is_work: res.is_work,
                    is_absence: res.is_absence,
                    is_on_site: res.is_on_site,
                };
            });
            const ht_work = {
                name: "Présence",
                content: res.filter((ht) => ht.is_absence !== true),
            };
            const ht_abs = {
                name: "Absence",
                content: res.filter((ht) => ht.is_absence === true),
            };
            setHoursType([ht_work, ht_abs]);
        });
    };

    const loadDayModel = async () => {
        setIsLoading(true);
        loadHoursTypes();
        if (dm_id) {
            await getDayModel(dm_id)
                .then((resp) => {
                    setName(resp.data.name);
                    setHourSlices(resp.data.day_model_details);
                })
                .catch((resp) => {
                    // Accés refusé ?
                    toast("Accès refusé.");
                    navigate("/company/time");
                });
        }
        setIsLoading(false);
    };

    useEffect(() => {
        loadDayModel();
    }, [dm_id]);

    const setStartTime = (e, index) => {
        const aDetail = hourSlices[index];
        aDetail.start_time = e;
        setHourSlices(hourSlices.map((hs, i) => (i === index ? aDetail : hs)));
    };
    const setEndTime = (e, index) => {
        const aDetail = hourSlices[index];
        aDetail.end_time = e;
        setHourSlices(hourSlices.map((hs, i) => (i === index ? aDetail : hs)));
    };
    const setHourType = (e, index) => {
        const aDetail = hourSlices[index];
        aDetail.hour_type_id = e;
        setHourSlices(hourSlices.map((hs, i) => (i === index ? aDetail : hs)));
    };

    const addHourSlice = () => {
        let startTime = new Date();
        let endTime = new Date();
        startTime.setHours(8, 30, 0);
        endTime.setHours(12, 0, 0);

        const size = hourSlices.length;
        if (size > 0) {
            const startHour = parseInt(
                hourSlices[size - 1].end_time.substring(0, 2)
            );
            const endHour =
                parseInt(hourSlices[size - 1].end_time.substring(0, 2)) + 1;
            const aMinute = parseInt(
                hourSlices[size - 1].end_time.substring(3, 5)
            );
            startTime.setHours(startHour, aMinute);
            endTime.setHours(endHour, aMinute);
        }

        const aDetail = {
            start_time: startTime.toTimeString().substring(0, 5),
            end_time: endTime.toTimeString().substring(0, 5),
            hour_type_id: defaultHourTypeId.current,
        };
        setHourSlices(sortSlices([...hourSlices, aDetail]));
    };

    const removeHourSlice = (index) => {
        setHourSlices(hourSlices.filter((hs, i) => i !== index));
    };

    const sortSlices = (slices) => {
        const orderedSlices = [...slices];
        orderedSlices.sort((a, b) => {
            const x = new Date(
                2000,
                1,
                1,
                parseInt(a.start_time.substring(0, 2)),
                parseInt(a.start_time.substring(3, 5))
            );
            const y = new Date(
                2000,
                1,
                1,
                parseInt(b.start_time.substring(0, 2)),
                parseInt(b.start_time.substring(3, 5))
            );
            return x - y;
        });
        return orderedSlices;
    };

    const mergeSlices = (slices) => {
        const mergedSlices = sortSlices([...slices]);
        for (let i = mergedSlices.length - 1; i > 0; i--) {
            if (
                mergedSlices[i - 1].end_time.substring(0, 5) ==
                mergedSlices[i].start_time.substring(0, 5) &&
                mergedSlices[i - 1].hour_type_id == mergedSlices[i].hour_type_id
            ) {
                mergedSlices[i - 1].end_time = mergedSlices[i].end_time;
                mergedSlices.splice(i, 1);
            }
        }
        return mergedSlices;
    };

    const AddDayModel = () => {
        const payload = {
            name: name,
            day_model_details: mergeSlices(hourSlices),
        };

        if (!name) {
            toast.error("Le nom est obligatoire.");
            return;
        }

        setIsSaving(true);
        if (dm_id) {
            updateDayModel(dm_id, payload).then(() => {
                toast("Modification enregistrée.");
                navigate("/company/time");
            }).finally(() => {
                setIsSaving(false);
            });
        } else {
            createDayModel(payload)
                .then((request) => {
                    toast(
                        'Le modèle de journée "' +
                        payload.name +
                        '" a été créé.'
                    );
                    navigate("/company/time");
                })
                .catch((err) => {
                    console.log(err);
                    toast.error("Une erreur est survenue lors de la création du modèle de journée.");
                })
                .finally(() => {
                    setIsSaving(false);
                });
        }
    };

    const deleteDayModel = () => {
        if (dm_id) {
            setIsDeleting(true);
            destroyDayModel(dm_id)
                .then(() => {
                    toast(
                        'Le modèle de journée "' + name + '" a été supprimé.'
                    );
                    navigate("/company/time");
                })
                .catch((resp) => {
                    toast(
                        "Une erreur est survenue lors de la suppression du modèle de journée : " +
                        resp.message
                    );
                })
                .finally(() => {
                    setIsDeleting(false);
                });
            return;
        }
        navigate("/company/time");
    };

    return (
        <div className="min-h-full bg-gray-50">

            {/* Header */}
            <div className="bg-white border-b border-gray-200 shadow-sm">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <div className="flex items-center justify-between flex-wrap gap-4">
                        <div className="flex items-center space-x-4">
                            <BackButton
                                onClick={() => navigate("/company/time")}
                                title="Retour"
                            />
                            <div>
                                <h1 className="text-3xl font-bold text-gray-900">
                                    {dm_id ? "Modifier" : "Ajouter"} un modèle de journée
                                </h1>
                                <p className="mt-2 text-sm text-gray-600">
                                    Les modèles de journée sont utilisés pour définir les horaires de travail des employés.
                                </p>
                            </div>
                        </div>
                        <div className="flex flex-wrap gap-2">
                            {dm_id && (
                                <Button
                                    action={() => deleteDayModel()}
                                    type={"red"}
                                    name={"Supprimer"}
                                    loading={isDeleting}
                                />
                            )}
                            <Button
                                action={() => {
                                    AddDayModel();
                                }}
                                name={dm_id ? "Modifier" : "Ajouter"}
                                loading={isSaving}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {isLoading ? (
                <Loader text="Recherche en cours..." />
            ) : (

                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                        <div className="py-4 flex flex-wrap gap-4 justify-between">
                            <InputForm
                                name="Nom"
                                value={name}
                                placeholder="Nom du modèle"
                                type="text"
                                set={setName}
                                required={true}
                                classNameWrapper="w-96"
                            />

                            <Button
                                name="Ajouter une tranche"
                                action={addHourSlice}
                                type="empty"
                                id=""
                            />
                        </div>
                        {hourSlices.map((hs, index) => (
                            <HourSlice
                                key={index}
                                index={index}
                                nameStartTime="de"
                                nameEndTime="à"
                                nameHourType=""
                                listHourTypes={hoursType}
                                valueStartTime={hs.start_time}
                                valueEndTime={hs.end_time}
                                valueHourType={hs.hour_type_id}
                                setStartTime={setStartTime}
                                setEndTime={setEndTime}
                                setHourType={setHourType}
                                placeholder=""
                                className=""
                                classNameWrapper=""
                                onRemove={removeHourSlice}
                                desktopLayout="single"
                            />
                        ))}

                    </div>
                </div>
            )
            }
        </div>
    );
};

export default AddDayModel;
